import moment from 'moment';

function populateProfileFields($scope, profile) {
  $scope.tableName = profile.tableName;
  $scope.query = profile.query;
  $scope.rowCount = profile.rowCount;
}

angular.module('magpieProfiling', [
  'ui.bootstrap',
  'magpieUtil'
]).
directive('magpieSchemaProfile', function() {
  return {
    restrict: 'E',
    scope: {
      profile: '@'
    },
    templateUrl: 'components/magpie-display/profiling/schema-profile.html',
    controller: function($scope, $timeout) {
      $scope.ready = false;
      $timeout(function() {
        const profile = JSON.parse($scope.profile);
        $scope.schemaName = profile.schemaName;

        if (profile.tableSummaries.length > 50) {
          $timeout(function() {
            $scope.ready = true;
          }, 100);
        } else {
          $scope.ready = true;
        }
      });
    }
  };
}).
directive('magpieSchemaProfileDetails', function() {
  return {
    restrict: 'E',
    scope: true,
    templateUrl: 'components/magpie-display/profiling/schema-profile-details.html',
    controller: function($scope, $timeout) {
      $timeout(function() {
        $scope.profile = JSON.parse($scope.profile);
        $scope.profileTimestamp = moment($scope.profile.createdAt).format('MMMM DD YYYY, h:mm:ss A');
      });
    }
  };
}).
directive('magpieDataSetProfile', function() {
  return {
    restrict: 'E',
    scope: {
      profile: '@'
    },
    templateUrl: 'components/magpie-display/profiling/data-set-profile.html',
    controller: function($scope, $timeout) {
      $scope.ready = false;
      $timeout(function() {
        const profile = JSON.parse($scope.profile);
        populateProfileFields($scope, profile);

        if (profile.fieldProfiles.length > 50) {
          $timeout(function() {
            $scope.ready = true;
          }, 100);
        } else {
          $scope.ready = true;
        }
      });
    }
  };
}).
directive('magpieDataSetProfileDetails', function() {
  return {
    restrict: 'E',
    scope: true,
    templateUrl: 'components/magpie-display/profiling/data-set-profile-details.html',
    controller: function($scope, $timeout, $filter, ngToast) {
      const fields = [
        {
          'field': 'fieldName',
          'display': 'Name',
          'search': {text: undefined, operator: '=v'}
        },
        {
          'field': 'inferredProfileType',
          'display': 'Profile Type',
          'search': {
            text: undefined,
            operator: '=v'
          }
        },
        {
          'field': 'nullCount',
          'display': 'Null Values',
          'search': {text: undefined, operator: '<%'}
        },
        {
          'field': 'distinctValueCount',
          'display': 'Distinct Values',
          'search': {text: undefined, operator: '=v'}
        }
      ];


      $timeout(function() {
        $scope.fields = fields;

        $scope.profile = JSON.parse($scope.profile);
        $scope.fieldProfiles = $filter('filter')($scope.profile.fieldProfiles, $scope.searchText);
        $scope.ascending = true;
        $scope.sortField = 'fieldIndex';

        $scope.profileTimestamp = moment($scope.profile.createdAt).format('MMMM DD YYYY, h:mm:ss A');
      });

      $scope.generate_sql = function() {
        let filtered = handleFilter();
        let sql = 'SELECT\n\t' + filtered.map((f) => f.fieldName).join('\n\t, ') +
            '\nFROM\n\t' + $scope.profile.tableName;
        navigator.clipboard.writeText(sql).then((r) => ngToast.create('Copied query to clipboard.'));
      };

      const handleFilter = function() {
        return $filter('filter')($scope.profile.fieldProfiles, $scope.filter_expression);
      };

      $scope.handle_clear_filters = function() {
        $scope.ascending = true;
        $scope.sortField = 'fieldIndex';
        $scope.fields.forEach((f) => f.search.text = undefined);
      };

      $scope.handleSortClick = function(field) {
        $timeout(function() {
          if (field === $scope.sortField) {
            $scope.ascending = !$scope.ascending;
          } else {
            $scope.sortField = field;
            $scope.ascending = true;
          }
        });
      };

      $scope.filter_expression = function(value, index, array) {
        return compareText(value) &&
            compareField('fieldName', value) &&
            compareField('inferredProfileType', value) &&
            compareField('nullCount', value) &&
            compareField('distinctValueCount', value);
      };

      function compareText(value) {
        if($scope.searchText === undefined) {
          return true;
        }

        if(Object.keys(value).length === 0) {
          return false;
        }

        return Object.keys(value)
            .map((key) => {
              if (typeof(value[key]) === 'object') {
                return compareText(value[key]);
              } else {
                return value[key].toString().toLowerCase().contains($scope.searchText.toLowerCase());
              }
            })
            .reduce((a, b) => a || b);
      }

      function compareField(fieldName, value) {
        let field = $scope.fields.find((f) => f.field === fieldName);
        let v = value[field.field];
        if (field.search.operator.contains('%')) {
          v = 100*v/$scope.profile.rowCount;
        }

        if(field.search.text === undefined || field.search.text === null) {
          return true;
        } else if (typeof(value[field.field]) === 'number' && field.search.operator.contains('=')) {
          return field.search.text === v;
        } else if (typeof(value[field.field]) === 'number' && field.search.operator.contains('<')) {
          return v < field.search.text;
        } else if (typeof(value[field.field]) === 'number' && field.search.operator.contains('>')) {
          return v > field.search.text;
        } else {
          return value[field.field].toString().toLowerCase().contains(field.search.text.toString().toLowerCase());
        }
      }
    }
  };
}).
directive('magpieFieldProfile', function() {
  return {
    restrict: 'AE',
    scope: {
      profile: '<',
      rowCount: '<'
    },
    templateUrl: 'components/magpie-display/profiling/field-profile.html',
    controller: 'MagpieExpandableRowCtrl'
  };
}).
directive('magpieTopValues', function() {
  return {
    restrict: 'E',
    scope: true,
    templateUrl: 'components/magpie-display/profiling/top-values.html',
    controller: function($scope) {
      const topValueCount = _($scope.profile.topValues)
        .map('count')
        .sum();

      const data = _.map($scope.profile.topValues, (v) => {
        return {
          label: v.value,
          value: v.count,
          percent: v.count / $scope.rowCount
        };
      });

      if ($scope.rowCount > topValueCount) {
        const otherCount = $scope.rowCount - topValueCount - $scope.profile.nullCount;
        if (otherCount > 0) {
          data.push({
            label: 'Other',
            value: otherCount,
            percent: otherCount / $scope.rowCount
          });
        }
        if ($scope.profile.nullCount > 0) {
          data.push({
            label: 'Null',
            value: $scope.profile.nullCount,
            percent: $scope.profile.nullCount / $scope.rowCount
          });
        }
      }

      $scope.chartData = data;
    }
  };
}).
directive('magpieNumericalFieldProfile', function() {
  return {
    restrict: 'E',
    scope: true,
    templateUrl: 'components/magpie-display/profiling/numerical-field-profile.html'
  };
}).
directive('magpieDateFieldProfile', function() {
  return {
    restrict: 'E',
    scope: true,
    templateUrl: 'components/magpie-display/profiling/date-field-profile.html'
  };
}).
directive('magpieTimestampFieldProfile', function() {
  return {
    restrict: 'E',
    scope: true,
    templateUrl: 'components/magpie-display/profiling/timestamp-field-profile.html'
  };
}).
directive('magpieDayOfYearChart', function() {
  return {
    restrict: 'E',
    scope: true,
    templateUrl: 'components/magpie-display/profiling/time/day-of-year-chart.html',
    controller: function($scope) {
      // use a known leap year so we get February 29th
      const byValue = _.indexBy($scope.profile.countByDayOfYear, 'value');
      const m = moment.utc([2000]);
      // convert the data to integer day of year (in a leap year)
      const data = [];
      for (let i = 1; i <= 366; i++) {
        const value = m.dayOfYear(i).format('--MM-DD');
        const record = byValue[value];
        if (!_.isUndefined(record)) {
          data.push({
            value: i,
            count: record.count
          });
        }
      }

      $scope.countByDayOfYear = data;

      function formatDayOfYear(d, format) {
        return moment.utc([2000]).dayOfYear(d).format(format);
      }

      $scope.formatter = (d) => formatDayOfYear(d, 'D MMM');
    }
  };
}).
directive('magpieYearChart', function() {
  return {
    restrict: 'E',
    scope: true,
    templateUrl: 'components/magpie-display/profiling/time/year-chart.html'
  };
}).
directive('magpieMonthChart', function() {
  return {
    restrict: 'E',
    scope: true,
    templateUrl: 'components/magpie-display/profiling/time/month-chart.html',
    controller: function($scope) {
      function formatMonth(d, format) {
        if (_.isNumber(d)) {
          d -= 1;
        }
        return moment.utc(0).month(d).format(format);
      }

      $scope.shortFormatter = (d) => formatMonth(d, 'MMM');
      $scope.longFormatter = (d) => formatMonth(d, 'MMMM');
    }
  };
}).
directive('magpieDayOfMonthChart', function() {
  return {
    restrict: 'E',
    scope: true,
    templateUrl: 'components/magpie-display/profiling/time/day-of-month-chart.html'
  };
}).
directive('magpieDayOfWeekChart', function() {
  return {
    restrict: 'E',
    scope: true,
    templateUrl: 'components/magpie-display/profiling/time/day-of-week-chart.html',
    controller: function($scope) {
      function formatDayOfWeek(d, format) {
        return moment.utc(0).isoWeekday(d).format(format);
      }

      $scope.shortFormatter = (d) => formatDayOfWeek(d, 'ddd');
      $scope.longFormatter = (d) => formatDayOfWeek(d, 'dddd');
    }
  };
}).
directive('magpieHourOfDayChart', function() {
  return {
    restrict: 'E',
    scope: true,
    templateUrl: 'components/magpie-display/profiling/time/hour-of-day-chart.html'
  };
}).
directive('magpieMinuteOfHourChart', function() {
  return {
    restrict: 'E',
    scope: true,
    templateUrl: 'components/magpie-display/profiling/time/minute-of-hour-chart.html'
  };
});



// WEBPACK FOOTER //
// ./src/components/magpie-display/profiling/magpie-profiling.js